import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import { ListItem } from 'react-toolbox/lib/list';
import { Flex, Box } from 'reflexbox'
import Body1 from 'components/typography/body1/index'
import Body2 from 'components/typography/body2/index'

import styles from './styles.scss'

const ItemContent = ({name, value}) => (
  <Flex auto class={styles.property}>
    <Box w={0.2}><Body2>{name}</Body2></Box>
    <Box w={0.8}><Body1>{value}</Body1></Box>
  </Flex>
)

const DropdownContent = ({name, value}) => (
  <Flex auto class={styles.property}>
    <Box w={1}><Body2>{value}</Body2></Box>
  </Flex>
)

const ClockItem = (props) => {
  return (
    <ListItem
      itemContent={props.type === 'TextField' ? <ItemContent {...props}/> : <DropdownContent {...props}/>}
    />
  )
}

ItemContent.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])
}

const withStyle = CSSModules(styles)
export default withStyle(ClockItem)
